import { useEffect, useState } from 'react';
import { FieldProps, FieldValidation } from '@rjsf/utils';
import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { catalogApiRef, humanizeEntityRef } from '@backstage/plugin-catalog-react';
import TextField from '@material-ui/core/TextField';
import { MenuItem } from '@material-ui/core';

/*
 This is the actual component that will get rendered in the form
*/

export interface RepoNameState {
    system?: any;
    componentName?: any;
}

export const reponameValidationExtension = ({
    onChange,
}: FieldProps<string>) => {

    const catalogApi = useApi(catalogApiRef);
    const { value: systems } = useAsync(() =>
        catalogApi.getEntities({
            filter: {
                kind: "System"
            }
        }),
    );

    const systemRefs = systems?.items.map(e =>
        humanizeEntityRef(e, { defaultKind: 'System' }),
    );

    const [state, setState] = useState<RepoNameState>({
        system: null,
        componentName: null
    });

    function serializeRepoName(data: RepoNameState) {
        let fullName = 'sitecore.';
        if (data.system) {
            fullName += data.system.toLowerCase() + "."
        }
        if (data.componentName) {
            fullName += data.componentName
        }
        return (fullName)
    }

    useEffect(() => {
        onChange(serializeRepoName(state));
    }, [state, onChange]);

    return (
        <div>
            <TextField
                id="system"
                select
                required
                label="System"
                helperText="Please select your system"
                defaultValue=''
                onChange={e => { const system = e.target.value; setState(prevState => ({ ...prevState, system })) }}
            >
                {systemRefs?.map(option => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </TextField>
            <br />
            <TextField
                label="Component Name"
                margin="normal"
                helperText="Type your component name (Part after sitecore.<system>.)"
                required
                onChange={e => { const componentName = e.target.value; setState(prevState => ({ ...prevState, componentName })) }}
            />
        </div>
    );
};

/*
 This is a validation function that will run when the form is submitted.
  You will get the value from the `onChange` handler before as the value here to make sure that the types are aligned\
*/

export const reponameValidation = (
    value: string,
    validation: FieldValidation,
) => {

    function hasWhiteSpace(s: string) {
        return /\s/g.test(s);
    }
    function isLowerCase(input: string) {
        return input === String(input).toLowerCase()
    }
    const seperatorPattern = /\-|_/ig;

    if (hasWhiteSpace(value)) {
        validation.addError(
            'Repository name may not contain whitespace. (' + value + ')',
        );
    }
    if (value.split(".").length <= 2) {
        validation.addError(
            'Repository name must contain more than 2 parts (' + value + ')'
        )
    }
    if (value.split(".").length > 5) {
        validation.addError(
            'Repository name may not contain more than 5 parts (' + value + ')'
        )
    }
    if (seperatorPattern.test(value)) {
        validation.addError(
            'Repository name may not contain underscores or dashes (' + value + ')'
        )
    }
    if (!isLowerCase(value)) {
        validation.addError(
            'Repository name must be lowercase (' + value + ')'
        )
    }
};